module.exports = __webpack_public_path__ + "static/logo-a924506fbe9399b389fd2d5dc168f4f9.png";